import { render } from "./CampaignChannel.vue?vue&type=template&id=538f71ac&scoped=true"
import script from "./CampaignChannel.vue?vue&type=script&lang=js"
export * from "./CampaignChannel.vue?vue&type=script&lang=js"

import "./CampaignChannel.vue?vue&type=style&index=0&id=538f71ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538f71ac"]])

export default __exports__